export const LAST_MFA_DATA = 'LAST_MFA_DATA'